import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Input } from 'hljd'
import { observer } from 'mobx-react'
import { passwordRegExp } from '@util'
import store from './store'
const FormItem = Form.Item

@Form.create({
  onValuesChange: store.formValsChange
})
@observer
export default class extends Component {
  componentDidMount() {
    store.form = this.props.form
  }

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && store.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback(passwordRegExp(value))
  }

  checkPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('password')) {
      callback('请保持两次输入的密码一致！')
    } else {
      callback()
    }
  }

  handleConfirmBlur = e => {
    const value = e.target.value
    store.confirmDirty = store.confirmDirty || !!value
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }

    const { getFieldDecorator } = this.props.form

    const {
      params: { password, confirm },
      visible
    } = store

    return (
      visible && (
        <Modal
          title="修改密码"
          visible={visible}
          onOk={store.handleOk}
          onCancel={store.changePwd()}
          width={540}
        >
          <Form>
            <FormItem {...formItemLayout} label="登录密码">
              {getFieldDecorator('password', {
                initialValue: password,
                rules: [
                  {
                    required: true,
                    message: '请填写登录密码！'
                  },
                  {
                    validator: this.checkConfirm
                  }
                ]
              })(
                <Input
                  type="password"
                  placeholder="请输入8~20位登录密码"
                  autoComplete={'new-password'}
                />
              )}
            </FormItem>
            <FormItem {...formItemLayout} label="确认密码">
              {getFieldDecorator('confirm', {
                initialValue: confirm,
                rules: [
                  {
                    required: true,
                    message: '请填写确认密码！'
                  },
                  {
                    validator: this.checkPassword
                  }
                ]
              })(
                <Input
                  type="password"
                  onBlur={this.handleConfirmBlur}
                  placeholder="请确认密码"
                />
              )}
            </FormItem>
          </Form>
        </Modal>
      )
    )
  }
}
